import React from "react";

// SG-2164: skeleton "liner" loader shown in the breakdown area while a widget's
// "Breakdown by member" data is being fetched from the API. Mirrors MemberBreakdownList's
// row layout (name + value + bar track) so the loader occupies the same space the rows will,
// avoiding a layout jump when the real data arrives. Uses the shared `linear-background` shimmer.
const SKELETON_ROWS = 3;

const MemberBreakdownSkeleton = () => (
  <div className="widgetCardMemberBreakdown">
    {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
      <div key={i} className="widgetCardMemberBreakdownRow">
        <div className="widgetCardMemberBreakdownHeader">
          <span className="linear-background widgetBreakdownSkeletonName" />
          <span className="linear-background widgetBreakdownSkeletonValue" />
        </div>
        <div className="widgetCardMemberBreakdownBarTrack">
          <span className="linear-background widgetBreakdownSkeletonBar" />
        </div>
      </div>
    ))}
  </div>
);

export default MemberBreakdownSkeleton;
